import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface TableLabelDisplayedRowsProps {
  from: number;
  to: number;
  count: number;
  // Noun shown after the count ("items" by default — callers can override
  // with a context-specific word like "invitations" or "guests").
  itemLabel?: string;
}

const TableLabelDisplayedRows = ({ from, to, count, itemLabel }: TableLabelDisplayedRowsProps) => {
  const { t } = useTranslation();
  const label = itemLabel ?? t('common.pagination.items');

  return (
    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
      <Box component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
        {t('common.pagination.showing')}
      </Box>
      <Typography variant="caption" sx={{ fontWeight: 'bold', mx: 0.5 }}>
        {from}-{to} {t('common.pagination.out_of')} {count}
      </Typography>
      <Box component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
        {label}
      </Box>
    </Typography>
  );
};

export default TableLabelDisplayedRows;
